import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface RiskMaterialityLogState {
    data: [] | null | any;
    totalRecords: number | null;
    totalPages: number | null;
}

const initialState: RiskMaterialityLogState = {
    data: null,
    totalRecords: null,
    totalPages: null,
};

export const riskMaterialityLogSlice = createSlice({
    name: 'RiskMaterialityLog',
    initialState,
    reducers: {
        setRiskMaterialityLog: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
        },
        reset: (state) => {
            Object.assign(state, initialState);
        },
    },
});

export const { setRiskMaterialityLog, reset } = riskMaterialityLogSlice.actions;
export const getAllRiskMaterialityLogDetails = (state: RootState) => state.riskMaterialityLog.data;
export const getRiskMaterialityLogTotalRecords = (state: RootState) => state.riskMaterialityLog.totalRecords;
export default riskMaterialityLogSlice.reducer;
